/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { colors } from '@atlaskit/theme';
import moment from 'moment';
import { FormSpy } from '../../../components/form';
import { Sale } from '../types';
import SaleInvoicePreview from '../SaleInvoicePreview';
import { useCurrentCompany } from '../../auth/CurrentCompany';
import { useMatch } from 'react-router';
import EmailPreview from './EmailPreview';
import { EmailRender } from '@accountingbox/invoice-templates'

type Props = {};

const columnCss = css`
  flex: 1;
`;
const rowCss = css`
  display: flex;
`;

const invoice: Sale = {
  isNew: true,
  invoiceDate: new Date().toString(),
  dueDate: moment().add(14,'days').toDate().toString(),
  paymentTerm: 14,
  Lines: [
    {
      // account: {
      //   accountNumber: 8003010,
      //   description: 'Omzet NL Hoog tarief',
      // },
      // accountNumber: 8003010,
      description: 'Voorbeeld omschrijving',
      item: null,
      itemId: null,
      name: null,
      price: 100,
      quantity: 1,
      amount: 100,
      amountIncludingVat: 121,
      subAccount: null,
      subAccountId: null,
      vatAmount: 21,
      vatCode: {
        description: 'Verkopen Nederland hoog (21%)',
        displayName: 'NL 21%',
        id: 'V-NL-H',
        percentage: 21,
        rates: [{ beginDate: '2012-01-09T23:00:00.000Z', percentage: 21 }],
      },
      vatCodeId: 'V-NL-H',
      vatPercentage: 21,
    },
  ],
  // created: '2020-09-18T16:01:58.742Z',
  customer: {
    type: 'business',
    contactFirstName: 'Thymo',
    contactLastName: 'ter Doest',
    contactName: 'Thymo ter Doest',
    name: 'AdministratieBox B.V.',
    tradeName: 'AdministratieBox B.V.',
    website: 'www.accountingbox.nl',
    address: {
      line1: 'David Ricardostraat 13-7',
      postalCode: '7559 SH',
      city: 'Hengelo',
      country: 'NL',
    }
  },
  // customerId: '5e6a820e0770a346e8aeada0',
  description: '',
  invoiceNumber: '202000223',
  isCreditInvoice: false,
  // isImported: false,
  journalDate: '2020-09-21T00:00:00.000Z',
  status: 'draft',
  subtotalAmount: 100,
  totalVatAmount: 21,
  totalVatAmounts: [{vatCodeId: "V-NL-H", displayName: "NL 21%", percentage: 21, amount: 21}],
  totalAmount: 121
  // updated: '2020-09-21T19:13:38.087Z',
};

const InvoiceSettingsSplitPane: React.FC<Props> = ({ children }) => {
  let showEmail = useMatch({
    path: '/:id/sale/invoice-settings/email',
    caseSensitive: false,
    end: false,
  });
  let showRecurringEmail = useMatch({
    path: '/:id/sale/invoice-settings/recurring-email',
    caseSensitive: false,
    end: false,
  })

  return (
    <div css={rowCss}>
      <div
        css={css`
          flex: 1;
          height: 100vh;
          overflow: scroll;
        `}
      >
        {children}
      </div>
      <div
        css={[
          columnCss,
          css`
            overflow: scroll;
            height: 100vh;
            border-left: 2px solid ${colors.backgroundHover()};
          `,
        ]}
      >
        <FormSpy<any> subscription={{ values: true }}>
          {({ values }) => {
              invoice.description = values.defaultDescription;
              invoice.note = values.defaultNote;
              invoice.footer = values.defaultFooter;
              if(showEmail) {
                return <EmailRender email={values.emailTemplate} invoice={invoice}invoiceSettings={values} />;
              }
              if(showRecurringEmail) {
                return <EmailRender email={values.recurringEmailTemplate} invoice={invoice}invoiceSettings={values} />;
              }
            return (
              <SaleInvoicePreview
                invoice={invoice}
                invoiceSettings={values}
              />
            );
          }}
        </FormSpy>
      </div>
    </div>
  );
};

export default InvoiceSettingsSplitPane;
